import { useLocation } from 'react-router-dom';

import { isNavLinkActive } from '../tab-menu.helpers';

import { UseSubMenu } from './sub-menu.types';

export function useSubMenu({ customApplicationUrl }: UseSubMenu) {
  const location = useLocation();
  return {
    isCurrentlyActive: (url: string) =>
      isNavLinkActive(url, location, customApplicationUrl),
  };
}
